import React, { useState, useEffect } from 'react'
import { useRestaurant } from '../context/RestaurantContext';
import { restaurantService } from '../services';

const Sales = () => {
  const { salesData, setDashboardData, isRestaurantOpen } = useRestaurant();
  const [activeTab, setActiveTab] = useState<'Today' | 'This week' | 'This Month'>('Today');
  const [isLoading, setIsLoading] = useState(false);

  // Fetch dashboard data based on active tab
  useEffect(() => {
    const fetchSalesData = async () => {
      if (!isRestaurantOpen) {
        return; // Don't fetch if restaurant is closed
      }

      try {
        setIsLoading(true);
        
        // Map tab to API period
        const periodMap: Record<string, 'today' | 'week' | 'month'> = {
          'Today': 'today',
          'This week': 'week',
          'This Month': 'month',
        };

        const period = periodMap[activeTab] || 'today';

        const response = await restaurantService.getDashboardData(period);

        if (response.status && response.data) {
          setDashboardData(response.data);
        }
      } catch (error: any) {
        console.error('Error fetching sales data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSalesData();
  }, [activeTab, isRestaurantOpen, setDashboardData]);

  const salesItems = salesData?.items || [];
  const totalAmount = salesData?.totalSalesAmount || 0;

  return (
    <div className="bg-[#FAFAFA] dark:bg-gray-800 rounded-lg p-5 max-w-md border dark:border-gray-700 transition-colors">
      {/* Header */}
      <div className="flex items-center justify-between mb-4 pb-3 border-b-2 dark:border-gray-700">
        <h3 className="text-[#050505] dark:text-gray-200 font-Urbanist text-[16px] font-semibold">
          Your Sales
        </h3>
        {/* <svg 
          width="8" 
          height="14" 
          viewBox="0 0 8 14" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="cursor-pointer"
        >
          <path 
            d="M1 1L7 7L1 13" 
            stroke="#050505" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg> */}
      </div>

      {/* Tabs */}
      <div className="flex gap-4 mb-4 border-b border-gray-200 dark:border-gray-700 w-full">
        <button
          onClick={() => setActiveTab('Today')}
          className={`relative w-[30%] pb-2 text-[14px] font-Urbanist font-medium transition-colors duration-200
            ${activeTab === 'Today' ? 'text-[#FF8A00]' : 'text-gray-500'}`}
        >
          Today
          {activeTab === 'Today' && (
            <span className="absolute left-0 bottom-0 h-[2px] w-full bg-[#FF8A00] rounded-full"></span>
          )}
        </button>

        <button
          onClick={() => setActiveTab('This week')}
          className={`relative w-[30%] pb-2 text-[14px] font-Urbanist font-medium transition-colors duration-200
            ${activeTab === 'This week' ? 'text-[#FF8A00]' : 'text-gray-500'}`}
        >
          This week
          {activeTab === 'This week' && (
            <span className="absolute left-0 bottom-0 h-[2px] w-full bg-[#FF8A00] rounded-full"></span>
          )}
        </button>

        <button
          onClick={() => setActiveTab('This Month')}
          className={`relative w-[30%] pb-2 text-[14px] font-Urbanist font-medium transition-colors duration-200
            ${activeTab === 'This Month' ? 'text-[#FF8A00]' : 'text-gray-500'}`}
        >
          This Month
          {activeTab === 'This Month' && (
            <span className="absolute left-0 bottom-0 h-[2px] w-full bg-[#FF8A00] rounded-full"></span>
          )}
        </button>
      </div>

      {/* Loading State */}
      {isLoading ? (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#FF8A00]"></div>
        </div>
      ) : (
        <>
          {/* Sales Items List */}
          {salesItems.length > 0 ? (
            <>
              <div className="space-y-3 mb-4">
                {salesItems.map((item) => (
                  <div 
                    key={item.id}
                    className="flex items-center justify-between"
                  >
                    <span className="text-[#050505] dark:text-gray-200 font-Urbanist text-[14px] font-normal">
                      {item.quantity} x {item.dishName}
                    </span>
                    <span className="text-[#050505] dark:text-gray-200 font-Urbanist text-[14px] font-normal">
                      ₹{item.totalAmount?.toFixed(2)}
                    </span>
                  </div>
                ))}
              </div>

              {/* Total */}
              <div className="flex items-center justify-between pt-3 border-t border-gray-300 dark:border-gray-700">
                <span className="text-[#050505] dark:text-gray-200 font-Urbanist text-[16px] font-semibold">
                  Total
                </span>
                <span className="text-[#050505] dark:text-gray-200 font-Urbanist text-[16px] font-semibold">
                  ₹ {totalAmount.toFixed(2)}
                </span>
              </div>
            </>
          ) : (
            <div className="text-center py-8 text-gray-500 dark:text-gray-400 text-[14px]">
              No sales data available for this period
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default Sales